<template>
  <kst-page-list
    :catalog="SearchCatalog"
    :params="searchParams"
    :search="searchData"
    @init="handleInit"
    @load="handleLoad"
    @reset="handleReset"
  >
    <template #search="{ handleInput }">
      <Search
        :categoryOptions="categoryOptions"
        :searchData="searchData"
        @input="handleInput"
      />
    </template>
    <template #search-result="{ data }">
      <List
        :access="access"
        :items="data.List"
      />
    </template>
  </kst-page-list>
</template>

<script>
import Model from "../ExpcModel.js";
import SearchCatalog from "./SearchCatalog.js";
import Services from "../../../services/Api/ExpenseCategoryServices.js";

import Search from "./ExpcL_Search.vue";
import List from "./ExpcL_List.vue";

export default {
  components: {
    Search,
    List
  },
  data: () => ({
    Model: Model,
    SearchCatalog: SearchCatalog,
    access: {},
    searchData: {
      Search: "",
      IsActive: null,
      CategoryID: null
    },
    searchParams: ["Search", "IsActive", "CategoryID"],
    categoryOptions: {}
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadListData) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getListData(options);
      loadListData(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.categoryOptions = Model.createCategoryOptions(
        data.CategoryList, SearchCatalog.CategoryID.Label
      );
    },

    handleLoad(loadList) {
      const options = this.getListOptions();
      const config = Services.getList(options);
      loadList(config);
    },
    
    handleReset() {
      this.resetSearch();
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
    },

    resetSearch() {
      this.searchData.Search = "";
      this.searchData.IsActive = this.$kst.Search.OptionAll;
      this.searchData.CategoryID = this.$kst.Search.OptionAll;
    },

    getListOptions() {
      return {
        category:  this.$kst.Search.getValue(this.searchData.CategoryID),
        active: this.$kst.Search.getValue(this.searchData.IsActive),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.Fields
      };
    }
  }
}
</script>